(() => {
  const script = document.currentScript;
  const label = script?.dataset.personaliseLabel;

  // PageFly quick-add cards do not contain the engraving fields.
  // Send personalised name tags to their full product form instead.
  function productUrl(button) {
    const form = button.closest('form');
    if (!form) return null;
    const vendor = form.querySelector('[data-pf-type="ProductVendor"]');
    if (vendor?.textContent.trim().toLowerCase() !== 'tagidog') return null;
    const title = form.querySelector('[data-product-type="title"][data-href]');
    const href = title?.getAttribute('data-href');
    if (!href) return null;
    const url = new URL(href, window.location.origin);
    return url.origin === window.location.origin ? url.href : null;
  }

  function refreshLabels() {
    if (!label) return;
    document.querySelectorAll('button[data-pf-type="ProductATC"]').forEach((button) => {
      if (!productUrl(button)) return;
      const text = button.querySelector('[data-pf-type="Text"]');
      if (text) text.textContent = label;
      button.setAttribute('aria-label', label);
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button[data-pf-type="ProductATC"]');
    if (!button) return;
    const url = productUrl(button);
    if (!url) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshLabels, { once: true });
  } else {
    refreshLabels();
  }
})();
